import AppBase from './AppBase'
import routeConfigAuth from './routeConfigAuth'

var AppAuth = function(elementId, options) {
  AppBase(elementId, routeConfigAuth, options)
}

export default AppAuth;